<template>
  <a-spin :spinning="spinning">
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">   
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
              <span class="alert-inner--text"> {{errorMessage}}</span>
              <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
                 <span aria-hidden="true">&times;</span>
              </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
              <span class="alert-inner--text"> {{successMessage}}</span>
              <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
                 <span aria-hidden="true">&times;</span>
              </button>
          </base-alert>
        </div> 
        <div class="col-md-3" style="margin-bottom: -50px;">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{_.startCase(currentProfile)}}
          </h3>
          <h6 class="text-small text-muted mb-4" :class="type === 'dark' ? 'text-white'  : ''">
            Selected: {{checkedItems.length}}
          </h6>
        </div>
        <div class="col-md-9 text-right">
          <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class=" dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('print_list')">
                  <i class="fa fa-print"></i>
                  <span>Print</span>
              </div>
              <!-- <div class="dropdown-item">
                  <i class="fa fa-upload"></i>
                  <span>Import</span>
              </div> -->
              <div class="dropdown-item" @click.prevent="showActionDrawer('export_list')">
                  <i class="fa fa-download"></i>
                  <span>Export</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                  <i class="fa fa-list-ul"></i>
                  <span>Customize List</span>
              </div>
            </template> 
          </base-dropdown>

          <div v-if="checkedItems.length == 0">
           <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showAddOnChargeDrawer(0)">+ Create {{_.startCase(currentProfile)}}</base-button>
          </div>
  
          <div v-else>
            <base-button v-if="this.$parent.filterStatus != 'A'" class="float-right ml-1" type="default" size="sm" @click.prevent="massupdate('status','A')">Activate</base-button>
            <base-button v-if="this.$parent.filterStatus != 'I'" class="float-right ml-1" type="default" size="sm" @click.prevent="massupdate('status','I')">Deactivate</base-button> 
            <div class="ml-1"></div>
          </div>
        
        </div>        

      </div>
      
    </div>
    
    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
       <div v-if="profileAction == 'customize_list'">
         <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
          <ul v-if="availableFields.length > 0" class="list-group list-group-flush" style="width: 100%">
              <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                  <div class="row">
                      <div class="col-md-6">
                          AVAILABLE FIELDS
                      </div>
                      <div class="col-md-6">
                         <a-checkbox @change="onCheckAllField" :checked="fields.length == (availableFields.length + 4)" class="float-right"/>
                      </div>
                   </div>
              </li>
              <li class="list-group-item" style="font-size: 14px" v-for="field in availableFields" :key="field">
                   <div class="row">
                       <div class="col-md-6">
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{field.replace(/(^\w)/g, g => g[0].toUpperCase()).replace(/([-_]\w)/g, g => " " + g[1].toUpperCase()).trim()}}
                      </div>
                      <div class="col-md-6">
                          <a-checkbox @change="onCheckField(field)" :checked="fields.includes(field)" class="float-right"/>
                      </div>
                   </div>
              </li>
          </ul>

       </div>

       <div v-if="profileAction == 'export_list'">
         <h6 class="heading-small text-muted mb-4">Export Options</h6>
         <div>
            <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
                Export All
            </base-radio>
            <base-radio name="1" class="mb-3" v-model="filterStatus" value="1">
                Export Current Page
            </base-radio>
            <base-radio name="2" class="mb-3" v-model="filterStatus" value="2">
                Export Selected
            </base-radio>
            <base-radio name="3" class="mb-3" v-model="filterStatus" value="3">
                Export Filtered
            </base-radio>
          </div>

          <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
            <button type="button" class="btn btn-primary float-right" @click.prevent="download">Export</button> 
          </div>

        </div>

        <div v-if="profileAction == 'print_list'">
          <h6 class="heading-small text-muted mb-4">Print Options</h6>
        </div>
    </a-drawer>

    <a-drawer title="" :width="1740" placement="right" @close="onClose" :visible="addonchargeVisible">
      <add-on-charges-form v-on:refreshPage="refreshPage" :key="componentKey"
          :viewMode="viewMode"></add-on-charges-form>
    </a-drawer>

      <div class="table-responsive">
        <vuetable ref="vuetable"
                    :api-url="apiURL"
                    :http-options="httpOptions"
                    :fields="fields"
                    :sort-order="sortOrder"
                    :show-sort-icons="true"
                    :per-page="10"
                    :css="css.table"
                    pagination-path=""
                    data-path="data"
                    @vuetable:checkbox-toggled-all="log"
                    @vuetable:checkbox-toggled="log"
                    @vuetable:load-error="onLoadError"
                    @vuetable:pagination-data="onPaginationData">   
                      <template slot="actions" slot-scope="props">
                          <center>
                          <div class="table-button-container">
                              <button v-if="accessRights.includes('V')" id="view" class="btn btn-success btn-sm"
                                @click.prevent="showAddOnChargeDrawer(props.rowData.id)">View</button>

                              <button v-if="accessRights.includes('W') && props.rowData.status != 'Posted'" class="btn btn-warning btn-sm"
                                @click.prevent="showAddOnChargeDrawer(props.rowData.id)">Edit</button>

                              <a-popconfirm v-if="accessRights.includes('D') && props.rowData.status != 'Posted'" title="You are about to delete this record?"
                                @confirm="deleteRow(props.rowData.id)" okText="Delete" cancelText="Cancel">
                                <a class="btn btn-danger btn-sm text-white">Delete</a>
                              </a-popconfirm>

                          </div>
                          </center>
                      </template>
                      <template slot="status" slot-scope="props">
                          <center>
                          {{ (props.rowData.status == 'S') ? 'Saved' : 'Posted' }}
                          </center>
                      </template>

                  </vuetable>
      </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination"></vuetable-pagination>
      </div>
    </div>

  </div>
  </a-spin>
</template>

<script>
  import axios from "axios";
  import { mapState, mapActions } from 'vuex'
  import AddOnChargesForm from '../Documents/AddOnChargesForm.vue';
  
  import Vuetable from "vuetable-2/src/components/Vuetable";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js'
  

  var component_x;
  
  export default {
    name: 'profiles-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    components: {
        Vuetable,
        VuetablePagination,
        AddOnChargesForm
    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters']),
    },
    data() {
      return {
        spinning: false,
        viewMode: false,
        accessRights: [],
        addonchargeVisible: false,
        filterStatus: "",
        profileAction: "",
        checkedFields: ["id","status","company","supplier","amount","vat_amount","description","remarks","updated_at","updated_by","created_at","created_by"],
        checkedItems: [],
        availableFields: [],
        errorMessage: null,
        successMessage: null,
        componentKey: 0,
        drawerVisible: false,
        visible: false,
        apiURL: "",
        fields: ['__checkbox',"id","status","company","supplier","amount","vat_amount","description","remarks","updated_at","updated_by","created_at","created_by", '__slot:actions'],
        sortOrder: [
          {
            field: "id",
            direction: "desc"
          }
        ],
        httpOptions:{
            headers: {
                Authorization: 'Bearer ' + secureStorage.getItem("accessToken") , 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
            }
        },
        css: {
            table: {
              tableClass: 'table table-sm table-striped table-bordered table-hovered',
              loadingClass: 'loading'
            },
            pagination: {
              infoClass: 'pull-right',
              wrapperClass: 'vuetable-pagination pull-right',
              activeClass: 'btn-primary btn-sm',
              disabledClass: 'disabled',
              pageClass: 'btn btn-border',
              linkClass: 'btn btn-border',
              icons: {
                first: '',
                prev: '',
                next: '',
                last: '',
              },
            }
        } 
      }
    },
    watch: {
      currentApiURL: function() {
        this.$refs.vuetable.resetData()
        this.apiURL = this.currentApiURL
      },
      parameters: function() {
        this.apiURL = this.currentApiURL
        this.apiURL = this.apiURL + this.parameters
        this.$refs.vuetable.selectedTo = []
        this.checkedItems = []
      }
    },
    methods: {
        ...mapActions(['updateProfileId']),
        refreshPage(){
          this.onClose()
          this.$refs.vuetable.refresh()
          this.successMessage = "Successful Operation"
          this.errorMessage = null
        },
        showDrawer(id) {
          this.componentKey++
          this.updateProfileId(id)
          this.visible = true
        },
        showAddOnChargeDrawer(id){
          if (event.target.id == "view") {
            this.viewMode = true
          } else {
            this.viewMode = false
          }
          this.componentKey++
          this.addonchargeVisible = true
          this.updateProfileId(id)
        },
        async showActionDrawer(action) {
          if (action == "customize_list") {
            var response = await HTTPRequest.getRequest(
              this.endPoint + this.currentProfile + "/get_viewable_fields",
              null
            );
            
            let unsortedFields = response["fields"];
            let sortedFields = this.checkedFields.slice();

            unsortedFields.forEach(fieldName => {
              if (!this.checkedFields.includes(fieldName))
                sortedFields.push(fieldName)
            });

            this.availableFields = sortedFields;

          }
          this.profileAction = action;
          this.drawerVisible = true;
        },
        onClose() { 
          this.drawerVisible = false
          this.addonchargeVisible = false
          this.visible = false
          this.componentKey++
        },
        log(){
          this.checkedItems = this.$refs.vuetable.selectedTo
        },
        onCheckField(fieldName){
          if(this.fields.includes(fieldName)){
            var indexValue = this.fields.indexOf(fieldName)
            if(indexValue > -1) this.fields.splice(indexValue,1)
            var indexValue2 = this.checkedFields.indexOf(fieldName)
            if(indexValue2 > -1) this.checkedFields.splice(indexValue2,1)
          } else {
            this.fields.pop()
            this.fields.push(fieldName)
            this.fields.push("__slot:actions")
            this.checkedFields.push(fieldName)
          }
          // console.log(this.fields)
          localStorage.setItem("addOnChargeCustomList", JSON.stringify(this.checkedFields))
          this.$refs.vuetable.normalizeFields()
        },
        onCheckAllField(){
        },
        async massupdate(field_name,value){
          var field_update = {}
          field_update[field_name] = value
          var payload = {ids: this.checkedItems, field_update: field_update }
          var response = await HTTPRequest.postRequest(this.endPoint + this.currentProfile + "/mass_update" , null, payload)   
          if(response["message"] == "Ok"){
              this.successMessage = "Update successful!"
              this.$refs.vuetable.refresh()
              this.checkedItems = []
              this.$refs.vuetable.selectedTo = []
          } else {
              this.successMessage = "Update failed!"
              // alert("Error processing")
          }
        },
        onPaginationData(paginationData) {
          this.spinning = true;
          this.$refs.pagination.setPaginationData(paginationData);
          this.spinning = false;
        },
        async onLoadError(error){
          // request for new token or reauthenticate
          if(error.response.status == 401){
            var  auth_response = await HTTPRequest.authenticate(component_x.endPoint)   
            if(auth_response["status"] == "Ok"){
              this.$router.go();
            }else{
              alert("Cannot get access token. Please login again.")
              this.$router.push("/")
            }
          }   
        },
        onChangePage(page) {
          this.$refs.vuetable.changePage(page);
        },
        deleteRow(id){
            axios({
            method: 'delete',
            url: this.endPoint + this.currentProfile +'/' + id,
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
            })
            .then(function () {
                component_x.successMessage = "Successfully deleted record"
                component_x.$refs.vuetable.refresh()
            })
            .catch(function () {
                alert("Invalid Credentials")
            });
        },
        download(){
          var payload = {}
          var additional_parameters = ""
          var baseUrl = this.currentApiURL + "/download?file_type=csv"
          if(this.filterStatus == "0"){
            // All
            payload["type"] = "all"
          }else if(this.filterStatus == "1"){
            // Current Page
            var ids = this.$refs.vuetable.tableData.map(({ id }) => id)
            payload["type"] = "current_page";
            if (ids == 0) {
              this.errors.push('No Record(s)');
              return;
            } else {
              payload["ids"] = ids
            }
            // payload["type"] = "current_page"
            // additional_parameters = this.parameters
            // additional_parameters = additional_parameters + "&page=" + this.$refs.vuetable.currentPage + "&per_page=" + this.$refs.vuetable.perPage
          }else if(this.filterStatus == "2"){
            // Selected
            payload["type"] = "selected"
            payload["ids"] = this.checkedItems
          }else{
            // Filtered
            payload["type"] = "filtered"
            additional_parameters = this.parameters
          }
          
          var exportFields = this.fields
          var cbIndex = this.fields.indexOf("__checkbox");
          if(cbIndex > -1) exportFields.splice(cbIndex,1) 
          var actionIndex = this.fields.indexOf("__slot:actions"); 
          if(actionIndex > -1) exportFields.splice(actionIndex,1)

          payload["fields"] = exportFields
          additional_parameters = additional_parameters.replace('?','&');

          axios({
            url: baseUrl + additional_parameters ,
            method: 'POST',
            responseType: 'blob', // important
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
            data: payload,
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.currentProfile+'.csv');
            document.body.appendChild(link);
            link.click();
            this.onClose();
            this.filterStatus = null
            this.successMessage = "Download successful"
          });
        },
        displayMessage( message ){
          if(message["error"] != undefined){
            this.onClose()
            this.errorMessage = message["error"]
            this.successMessage = null
          }
        },
        removeMessage( type ){
          if(type == 'error')
            this.errorMessage = null
          else
            this.successMessage = null
        }
    },
    beforeMount: async function(){
      //const addOnChargeCustomList = localStorage.addOnChargeCustomList
      const addOnChargeCustomList = ["id","status","description","company","supplier","amount","vat_amount","remarks","updated_at","updated_by","created_at","created_by"]
      // console.log(addOnChargeCustomList)
      if(addOnChargeCustomList != undefined && addOnChargeCustomList != null && addOnChargeCustomList != "[]"){
        this.checkedFields = JSON.parse(addOnChargeCustomList)
        this.fields = JSON.parse(addOnChargeCustomList)
        this.fields.push("__slot:actions")
      }else{
        localStorage.removeItem("addOnChargeCustomList")
      }
    },
    mounted: function() {
        component_x = this;
        this.apiURL = this.currentApiURL
        this.accessRights = this.$attrs.accessRights
    }
  }
</script>

<style scoped>
</style>
